import { Button } from '@/atoms/Button/Button'
import { Popover } from '@/atoms/Popover/Popover'
import { CaptionMD } from '@/atoms/Text'
import { ExperimentVariation } from '@/experimentation'
import { FadeInExperiment } from '@/experimentation/components/FadeInExperiment/FadeInExperiment'
import { Callout } from '@/molecules/Callout'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  className?: string
}

export const FlexibleBookingCallout: React.FC<Props> = ({ className }) => {
  const { t } = useTranslate('tickets')

  return (
    <FadeInExperiment defaultValue={false} experimentName="flexible-booking-callout">
      <ExperimentVariation variation={true}>
        <Callout
          className={className}
          text={t('modifyTicketsWithFlexibleBooking', 'Modify tickets with Flexible Booking™.')}
          ctaComponent={
            <Popover
              title={t('flexibleBooking', 'Flexible Booking™')}
              description={t(
                'flexibleBookingDescriptionPill',
                "With Flexible Booking™, change your seat, showtime, or theater anytime up to an hour before the movie starts. To modify, click the link in your confirmation email or visit 'My Tickets' on Angel.com. Flexible Booking is only available Angel.com.",
              )}
              triggerComponent={
                <Button variant="plain">
                  <CaptionMD className="text-nowrap underline">{t('learnMore', 'Learn More')}</CaptionMD>
                </Button>
              }
            />
          }
          variant="info"
        />
      </ExperimentVariation>
    </FadeInExperiment>
  )
}
